import { useEffect } from "react";
import { getLocalStorageItem, useGlobalStore } from "@looksrare/utils";
import { LS_PTB_MUTED_KEY } from "@looksrare/config";

// Updates PTB setting on first load
export const useUpdatePtbSoundSetting = () => {
  const setPtbSoundMuted = useGlobalStore((state) => state.setPtbSoundMuted);
  useEffect(() => {
    const isMutedLs = Boolean(getLocalStorageItem(LS_PTB_MUTED_KEY));
    setPtbSoundMuted(isMutedLs);
  }, [setPtbSoundMuted]);
};
